/**
 * Child Theme - Scripts
 * File: custom-javascript.js
 * Description: file Js principale para el tema Child, qui vengono inizializzati i moduli js.
 *
 */

//import StickyNavbar from "./modules/sticky-navbar.js";
//import { initGallerySlider } from "./modules/gallery-slider";
import { setEqualHeightHeaders } from "./modules/equal-grid-height-headers";
import { initExpandingCards } from "./modules/expanding-cards";
import { initExpandingCardsSwiper } from "./modules/expanding-cards-swiper";
import { initMetricsSpotlight } from "./modules/initMetricsSpotlight";
import { initMarqueeBelt } from "./modules/marchee-belt-to-test";
import { initVerticalFeatureSlider } from "./modules/vertical-feature-slider";
import { initMegaMenu } from "./modules/megamenu-to-test";
import { initLoadMorePosts } from "./modules/init-ajax-load-more";
import { initMobileSliders } from "./modules/init-mobile-sliders";
import { initDragScrollComparison } from "./modules/drag-scroll-comparison";
import { initFaqAjaxSearch } from "./modules/init-faq-ajax-search";
import { initComparePlans } from "./modules/init-compare-plans";
import { initMobileMultilevelMenu } from "./modules/init-mobile-multilevel-menu";


// Inizializzazioni al caricamento del DOM

document.addEventListener("DOMContentLoaded", function () {
    console.log("WP Custom Theme → DOM pronto 👍");

    // Inizializza la Navbar sticky
    //StickyNavbar.initialize("mainNavbar");

    // Inizializza lo gallery slider, attivato solo se necessario
    //initGallerySlider();

    // Inizializza il Mega Menu
    initMegaMenu();

    // Inizializza per impostare stessa altezza per i titoli delle cards in .cards-grid e in .expanding-cards
    setEqualHeightHeaders();

    // 👉 1 - Inizializza le Cards expandibili in .expanding-cards, gestisce accessibilità e toggle
    initExpandingCards();
    // 👉 2 - Inizializza lo swiper per le expanding-cards, attivato solo su mobile
    initExpandingCardsSwiper();

    // Inizializza metriche spotlight
    initMetricsSpotlight();

    // Inizializza il marquee slider
    document.querySelectorAll(".marquee-belt").forEach(initMarqueeBelt);

    // Inizializza il vertical feature slider
    initVerticalFeatureSlider();

    // Inizializza il load more per i post
    initLoadMorePosts();

    // Sliders mobile-only (News, Piani, ecc)
    initMobileSliders();

    // Tabella comparativa: drag-to-scroll
    initDragScrollComparison();

    // Ricerca FAQ AJAX
    initFaqAjaxSearch();

    // Inizializza Slide Confronta piani e switch
    initComparePlans();

    // Inizializza gestione multilivello menu mobile
    initMobileMultilevelMenu();
});
